// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══ Admin Panel ═══════════════════════════════════════════════════════════ */

.adm-wrap {
  min-height: calc(100vh - var(--topbar-h, 62px));
  display: flex;
  background: #050308;
  font-family: 'Segoe UI', sans-serif;
}

/* ── Sidebar ── */
.adm-sidebar {
  width: 220px;
  flex-shrink: 0;
  background: linear-gradient(180deg, #0a0618 0%, #060312 100%);
  border-right: 1px solid rgba(240, 192, 64, 0.14);
  display: flex;
  flex-direction: column;
  padding: 24px 0 16px;
  min-height: 100%;
}

.adm-sidebar-title {
  font-family: 'Cinzel', Georgia, serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  color: rgba(240, 192, 64, 0.5);
  padding: 0 20px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  margin-bottom: 8px;
}

.adm-nav-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 11px 20px;
  background: none;
  border: none;
  border-left: 3px solid transparent;
  color: rgba(210, 195, 250, 0.6);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  cursor: pointer;
  text-align: left;
  transition: all 0.15s;
}

.adm-nav-btn:hover {
  background: rgba(255, 255, 255, 0.04);
  color: rgba(210, 195, 250, 0.9);
}

.adm-nav-btn.active {
  background: rgba(240, 192, 64, 0.07);
  border-left-color: #f0c040;
  color: #f0c040;
}

.adm-nav-icon { font-size: 15px; width: 20px; text-align: center; }

.adm-badge {
  margin-left: auto;
  background: rgba(240, 100, 64, 0.85);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 10px;
  padding: 1px 7px;
  min-width: 18px;
  text-align: center;
}

/* ── Main content ── */
.adm-main {
  flex: 1 1;
  padding: 28px 32px;
  overflow-y: auto;
  min-width: 0;
}

.adm-section-title {
  font-family: 'Cinzel', Georgia, serif;
  font-size: 16px;
  font-weight: 700;
  color: #f0c040;
  letter-spacing: 2px;
  margin-bottom: 20px;
}

/* ── Stat cards ── */
.adm-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
  margin-bottom: 32px;
}

.adm-stat-card {
  background: linear-gradient(135deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02));
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 18px 20px;
  transition: border-color 0.2s;
}

.adm-stat-card:hover { border-color: rgba(240, 192, 64, 0.25); }

.adm-stat-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 2px;
  color: rgba(210, 195, 250, 0.45);
  text-transform: uppercase;
  margin-bottom: 6px;
}

.adm-stat-value {
  font-size: 28px;
  font-weight: 800;
  color: #fff;
  line-height: 1;
}

.adm-stat-sub {
  font-size: 11px;
  color: rgba(240, 100, 64, 0.85);
  margin-top: 4px;
}

/* ── Toolbar row ── */
.adm-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.adm-search {
  flex: 1 1;
  min-width: 180px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 7px;
  color: #fff;
  font-size: 13px;
  padding: 8px 12px;
  outline: none;
  transition: border-color 0.15s;
}

.adm-search::placeholder { color: rgba(255, 255, 255, 0.25); }
.adm-search:focus { border-color: rgba(240, 192, 64, 0.4); }

.adm-select {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 7px;
  color: rgba(210, 195, 250, 0.8);
  font-size: 12px;
  padding: 8px 10px;
  cursor: pointer;
  outline: none;
}

.adm-select option { background: #0a0618; color: #fff; }

/* ── Table ── */
.adm-table-wrap {
  overflow-x: auto;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.07);
}

.adm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.adm-table thead tr {
  background: rgba(255, 255, 255, 0.04);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.adm-table th {
  padding: 10px 14px;
  text-align: left;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.5px;
  color: rgba(210, 195, 250, 0.4);
  text-transform: uppercase;
  white-space: nowrap;
}

.adm-table td {
  padding: 11px 14px;
  color: rgba(255, 255, 255, 0.82);
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  vertical-align: middle;
}

.adm-table tbody tr:last-child td { border-bottom: none; }

.adm-table tbody tr:hover td { background: rgba(255, 255, 255, 0.025); }

.adm-id-cell { color: rgba(255, 255, 255, 0.25); font-size: 11px; }

.adm-name-cell { font-weight: 600; color: #fff; }

.adm-email-cell { color: rgba(210, 195, 250, 0.55); font-size: 12px; }

.adm-date-cell { color: rgba(255, 255, 255, 0.3); font-size: 11px; white-space: nowrap; }

/* ── Role badge ── */
.adm-role {
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  border-radius: 5px;
  padding: 2px 8px;
  text-transform: uppercase;
}

.adm-role-admin   { background: rgba(240,64,64,0.18);  color: #ff7070; border: 1px solid rgba(240,64,64,0.3);  }
.adm-role-partner { background: rgba(240,192,64,0.14); color: #f0c040; border: 1px solid rgba(240,192,64,0.3); }
.adm-role-user    { background: rgba(123,79,212,0.14); color: #b09af0; border: 1px solid rgba(123,79,212,0.25); }

/* ── Status badge ── */
.adm-status {
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  border-radius: 5px;
  padding: 2px 8px;
}

.adm-status-approved { background: rgba(64,200,100,0.15); color: #50e080; border: 1px solid rgba(64,200,100,0.3); }
.adm-status-pending  { background: rgba(240,192,64,0.12); color: #f0c040; border: 1px solid rgba(240,192,64,0.25); }
.adm-status-rejected { background: rgba(240,64,64,0.12);  color: #ff7070; border: 1px solid rgba(240,64,64,0.25); }

/* ── Active toggle ── */
.adm-active-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
}

.adm-active-badge.on  { color: #50e080; }
.adm-active-badge.off { color: rgba(255,255,255,0.25); }

/* ── Action buttons ── */
.adm-actions { display: flex; align-items: center; gap: 6px; }

.adm-btn {
  border: none;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}

.adm-btn-approve  { background: rgba(64,200,100,0.15); color: #50e080; border: 1px solid rgba(64,200,100,0.25); }
.adm-btn-approve:hover { background: rgba(64,200,100,0.28); }

.adm-btn-reject   { background: rgba(240,100,64,0.15); color: #ff9060; border: 1px solid rgba(240,100,64,0.25); }
.adm-btn-reject:hover  { background: rgba(240,100,64,0.28); }

.adm-btn-toggle   { background: rgba(240,192,64,0.12); color: #f0c040; border: 1px solid rgba(240,192,64,0.22); }
.adm-btn-toggle:hover  { background: rgba(240,192,64,0.22); }

.adm-btn-delete   { background: rgba(240,40,40,0.12);  color: #ff5050; border: 1px solid rgba(240,40,40,0.22); }
.adm-btn-delete:hover  { background: rgba(240,40,40,0.25); }

.adm-btn-sm { padding: 3px 8px; font-size: 10px; }

/* ── Role select inline ── */
.adm-role-select {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 5px;
  color: rgba(210, 195, 250, 0.8);
  font-size: 11px;
  padding: 3px 6px;
  cursor: pointer;
  outline: none;
}

.adm-role-select option { background: #0a0618; }

/* ── Pagination ── */
.adm-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 20px;
}

.adm-page-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  color: rgba(210, 195, 250, 0.7);
  font-size: 12px;
  font-weight: 600;
  padding: 5px 12px;
  cursor: pointer;
  transition: all 0.15s;
}

.adm-page-btn:hover:not(:disabled) { background: rgba(240, 192, 64, 0.1); color: #f0c040; border-color: rgba(240, 192, 64, 0.3); }
.adm-page-btn:disabled { opacity: 0.3; cursor: default; }
.adm-page-btn.current { background: rgba(240, 192, 64, 0.14); color: #f0c040; border-color: rgba(240, 192, 64, 0.35); }

.adm-page-info { font-size: 12px; color: rgba(255, 255, 255, 0.3); }

/* ── Empty ── */
.adm-empty {
  text-align: center;
  padding: 48px 20px;
  color: rgba(255, 255, 255, 0.2);
  font-size: 14px;
}

/* ── Loading ── */
.adm-loading {
  text-align: center;
  padding: 40px;
  color: rgba(210, 195, 250, 0.4);
  font-size: 13px;
}

/* ── Log table ── */
.adm-log-ok  { color: #50e080; }
.adm-log-bad { color: #ff7070; }

/* ── Modal form inputs ── */
.adm-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: rgba(200, 180, 255, 0.5);
  text-transform: uppercase;
  margin-bottom: 5px;
}

.adm-input {
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #fff;
  font-size: 13px;
  padding: 8px 12px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
  font-family: inherit;
}

.adm-input:focus { border-color: rgba(240, 192, 64, 0.4); }
.adm-input::placeholder { color: rgba(255, 255, 255, 0.2); }

.adm-textarea {
  width: 100%;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 6px;
  padding: 8px 10px;
  color: rgba(255,255,255,0.88);
  font-size: 13px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.15s;
  box-sizing: border-box;
}
.adm-textarea:focus { border-color: rgba(240,192,64,0.4); outline: none; }

.adm-field-label {
  display: block;
  font-size: 11px;
  color: rgba(255,255,255,0.45);
  margin-bottom: 4px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

/* ── Export/Import toolbar group ── */
.adm-export-group {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 7px;
  padding: 4px 8px;
}

.adm-export-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  color: rgba(210,195,250,0.35);
  text-transform: uppercase;
  margin-right: 4px;
  white-space: nowrap;
}

/* ── Progress bar ── */
.adm-progress-wrap {
  margin: 10px 0 14px;
  padding: 12px 16px;
  background: rgba(240,192,64,0.05);
  border: 1px solid rgba(240,192,64,0.18);
  border-radius: 8px;
}

.adm-progress-label {
  font-size: 12px;
  color: rgba(200,180,255,0.65);
  margin-bottom: 8px;
}

.adm-progress-bar {
  height: 5px;
  background: rgba(255,255,255,0.06);
  border-radius: 3px;
  overflow: hidden;
}

.adm-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #f0c040, #ffdc70);
  border-radius: 3px;
  transition: width 0.3s ease;
}

/* ── Error bar ── */
.adm-error-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: rgba(240,64,64,0.1);
  border: 1px solid rgba(240,64,64,0.25);
  border-radius: 7px;
  color: #ff8080;
  font-size: 12px;
  padding: 9px 14px;
  margin-bottom: 12px;
}

.adm-error-bar button {
  background: none;
  border: none;
  color: #ff8080;
  font-size: 16px;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}

/* ── Type / status inline badges ── */
.adm-type-badge {
  font-size: 10px;
  color: rgba(210,195,250,0.5);
  background: rgba(123,79,212,0.1);
  border: 1px solid rgba(123,79,212,0.15);
  border-radius: 4px;
  padding: 1px 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.adm-status-dot {
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

/* ── Modal backdrop + box ── */
.adm-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0,0,0,0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.adm-modal-box {
  background: #0d0a18;
  border: 1px solid rgba(240,192,64,0.22);
  border-radius: 16px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  padding: 28px;
}

.adm-modal-title {
  font-family: 'Cinzel', serif;
  font-size: 15px;
  color: #f0c040;
  margin-bottom: 20px;
}

/* ── External import button ── */
.adm-btn-ext-import {
  background: linear-gradient(135deg, rgba(100,180,255,0.12), rgba(80,150,255,0.08));
  border: 1px solid rgba(100,180,255,0.3);
  color: #80c8ff;
  font-weight: 700;
  white-space: nowrap;
}
.adm-btn-ext-import:hover:not(:disabled) {
  background: rgba(100,180,255,0.2);
  border-color: rgba(100,180,255,0.55);
}
.adm-btn-ext-import:disabled {
  opacity: 0.55;
  cursor: default;
}

/* ── External import results panel ── */
.adm-ext-results {
  background: rgba(10,6,24,0.9);
  border: 1px solid rgba(100,180,255,0.2);
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
}
.adm-ext-results-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(100,180,255,0.07);
  border-bottom: 1px solid rgba(100,180,255,0.15);
  padding: 9px 14px;
  font-size: 12px;
  font-weight: 700;
  color: #80c8ff;
  letter-spacing: 0.5px;
}
.adm-ext-results-header button {
  background: none;
  border: none;
  color: rgba(200,180,255,0.5);
  font-size: 16px;
  cursor: pointer;
  line-height: 1;
  padding: 0 4px;
}
.adm-ext-result-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  font-size: 12px;
  border-bottom: 1px solid rgba(255,255,255,0.04);
}
.adm-ext-result-row:last-child { border-bottom: none; }
.adm-ext-ok    { background: rgba(80,224,128,0.04); }
.adm-ext-skip  { background: rgba(240,192,64,0.03); opacity: 0.65; }
.adm-ext-error { background: rgba(255,80,80,0.04); opacity: 0.7; }
.adm-ext-status { font-size: 14px; flex-shrink: 0; }
.adm-ext-ok    .adm-ext-status { color: #50e080; }
.adm-ext-skip  .adm-ext-status { color: #f0c040; }
.adm-ext-error .adm-ext-status { color: #ff5050; }
.adm-ext-title {
  flex: 1 1;
  color: rgba(220,210,255,0.85);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.adm-ext-reason {
  font-size: 10px;
  color: rgba(200,180,255,0.4);
  white-space: nowrap;
}

/* ── External source badge in table ── */
.adm-ext-badge {
  display: inline-block;
  font-size: 11px;
  margin-right: 5px;
  vertical-align: middle;
  opacity: 0.7;
}

/* ── Heatmap tab ── */
.adm-hm-stats {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.adm-hm-stat {
  flex: 1 1;
  min-width: 100px;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 8px;
  padding: 12px 16px;
}
.adm-hm-stat-val {
  font-family: 'Cinzel', serif;
  font-size: 22px;
  font-weight: 700;
  color: #f0c040;
  line-height: 1.1;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.adm-hm-stat-lbl {
  font-size: 10px;
  color: rgba(200,180,255,0.4);
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* ── Light theme overrides for admin panel ── */
body.light .adm-wrap           { background: #eef3fb; }
body.light .adm-sidebar        { background: linear-gradient(180deg,#1a1050 0%,#231466 100%); }
body.light .adm-content        { background: #f4f8ff; }
body.light .adm-card           { background: #ffffff; border-color: rgba(15,32,63,0.12); }
body.light .adm-table          { color: #101a34; }
body.light .adm-table thead tr { background: rgba(91,88,214,0.08); }
body.light .adm-table th       { color: #5b58d6; border-color: rgba(15,32,63,0.10); }
body.light .adm-table td       { border-color: rgba(15,32,63,0.07); color: #354161; }
body.light .adm-table tr:hover { background: rgba(91,88,214,0.05); }
body.light .adm-section-title  { color: #101a34; border-color: rgba(91,88,214,0.2); }
body.light .adm-modal-box      { background: #ffffff; border-color: rgba(91,88,214,0.2); }
body.light .adm-modal-title    { color: #4e46b4; }
body.light .adm-input          { background: #f4f8ff; border-color: rgba(15,32,63,0.18); color: #101a34; }
body.light .adm-input:focus    { border-color: #5b58d6; }
body.light .adm-textarea       { background: #f4f8ff; border-color: rgba(15,32,63,0.18); color: #101a34; }
body.light .adm-select         { background: #f4f8ff; border-color: rgba(15,32,63,0.18); color: #354161; }
body.light .adm-select option  { background: #fff; color: #101a34; }
body.light .adm-toolbar        { background: rgba(91,88,214,0.05); border-color: rgba(15,32,63,0.10); }
body.light .adm-loading        { color: #5d6a88; }
body.light .adm-empty          { color: #5d6a88; }
body.light .adm-id-cell        { color: #5b58d6; }
body.light .adm-name-cell      { color: #101a34; }
body.light .adm-email-cell     { color: #354161; }
body.light .adm-date-cell      { color: #5d6a88; }
body.light .adm-pagination     { border-color: rgba(15,32,63,0.10); }
body.light .adm-page-btn       { background: rgba(91,88,214,0.06); border-color: rgba(91,88,214,0.18); color: #354161; }
body.light .adm-page-btn.current { background: #5b58d6; color: #fff; border-color: #5b58d6; }
body.light .adm-page-info      { color: #5d6a88; }
body.light .adm-hm-stat        { background: rgba(91,88,214,0.06); border-color: rgba(91,88,214,0.12); }
body.light .adm-hm-stat-val    { color: #4e46b4; }
body.light .adm-hm-stat-lbl    { color: #5d6a88; }
body.light .adm-field-label    { color: #5d6a88; }

.adm-hm-wrap {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.adm-hm-legend {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 11px;
  color: rgba(200,180,255,0.45);
}
.adm-hm-gradient {
  flex: 1 1;
  max-width: 220px;
  height: 10px;
  border-radius: 5px;
  background: linear-gradient(90deg,
    rgba(0,0,255,0.6),
    rgba(0,200,255,0.7),
    rgba(0,255,100,0.8),
    rgba(255,255,0,0.9),
    rgba(255,130,0,1),
    rgba(255,0,0,1)
  );
}

.adm-hm-canvas-wrap {
  position: relative;
  width: 100%;
  background: #080510;
  border: 1px solid rgba(240,192,64,0.1);
  border-radius: 8px;
  overflow: hidden;
  aspect-ratio: 16/9;
}
.adm-hm-canvas {
  width: 100%;
  height: 100%;
  display: block;
}
.adm-hm-grid {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px);
  background-size: 10% 10%;
}
.adm-hm-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Cinzel', serif;
  font-size: 13px;
  letter-spacing: 2px;
  color: rgba(200,180,255,0.35);
  text-transform: uppercase;
  background: rgba(5,3,8,0.7);
  z-index: 2;
}

.adm-hm-top {
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 8px;
  padding: 14px 16px;
}
.adm-hm-top-title {
  font-family: 'Cinzel', serif;
  font-size: 10px;
  color: rgba(240,192,64,0.6);
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 10px;
}
.adm-hm-top-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 0;
  border-bottom: 1px solid rgba(255,255,255,0.04);
  font-size: 11px;
}
.adm-hm-top-row:last-child { border-bottom: none; }
.adm-hm-top-rank { color: rgba(240,192,64,0.5); font-weight: 700; width: 24px; flex-shrink: 0; }
.adm-hm-top-pos  { color: rgba(200,180,255,0.6); width: 120px; flex-shrink: 0; font-family: monospace; font-size: 10px; }
.adm-hm-top-bar-wrap { flex: 1 1; height: 6px; background: rgba(255,255,255,0.06); border-radius: 3px; overflow: hidden; }
.adm-hm-top-bar  { height: 100%; background: linear-gradient(90deg, #4040ff, #ff2020); border-radius: 3px; transition: width .4s ease; }
.adm-hm-top-cnt  { color: #f0c040; font-weight: 700; width: 36px; text-align: right; flex-shrink: 0; }

/* ── Responsive ── */
@media (max-width: 768px) {
  .adm-wrap { flex-direction: column; }
  .adm-sidebar { width: 100%; flex-direction: row; overflow-x: auto; padding: 8px; gap: 4px; border-right: none; border-bottom: 1px solid rgba(240,192,64,0.14); }
  .adm-sidebar-title { display: none; }
  .adm-nav-btn { border-left: none; border-bottom: 2px solid transparent; padding: 8px 14px; white-space: nowrap; border-radius: 6px; }
  .adm-nav-btn.active { border-bottom-color: #f0c040; border-left-color: transparent; }
  .adm-main { padding: 16px; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/admin.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;EACE,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,cAAc;EACd,6DAA6D;EAC7D,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,gBAAgB,eAAe,EAAE,WAAW,EAAE,kBAAkB,EAAE;;AAElE;EACE,iBAAiB;EACjB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mFAAmF;EACnF,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,uBAAuB,sCAAsC,EAAE;;AAE/D;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;;AAEA,2BAA2B,gCAAgC,EAAE;AAC7D,oBAAoB,qCAAqC,EAAE;;AAE3D;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA,qBAAqB,mBAAmB,EAAE,WAAW,EAAE;;AAEvD,gBAAgB;AAChB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA,oCAAoC,mBAAmB,EAAE;;AAEzD,+BAA+B,sCAAsC,EAAE;;AAEvE,eAAe,gCAAgC,EAAE,eAAe,EAAE;;AAElE,iBAAiB,gBAAgB,EAAE,WAAW,EAAE;;AAEhD,kBAAkB,gCAAgC,EAAE,eAAe,EAAE;;AAErE,iBAAiB,+BAA+B,EAAE,eAAe,EAAE,mBAAmB,EAAE;;AAExF,qBAAqB;AACrB;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,oBAAoB,gCAAgC,GAAG,cAAc,EAAE,qCAAqC,GAAG;AAC/G,oBAAoB,iCAAiC,EAAE,cAAc,EAAE,sCAAsC,EAAE;AAC/G,oBAAoB,iCAAiC,EAAE,cAAc,EAAE,uCAAuC,EAAE;;AAEhH,uBAAuB;AACvB;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB,iCAAiC,EAAE,cAAc,EAAE,sCAAsC,EAAE;AAClH,uBAAuB,iCAAiC,EAAE,cAAc,EAAE,uCAAuC,EAAE;AACnH,uBAAuB,gCAAgC,GAAG,cAAc,EAAE,sCAAsC,EAAE;;AAElH,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA,wBAAwB,cAAc,EAAE;AACxC,wBAAwB,6BAA6B,EAAE;;AAEvD,yBAAyB;AACzB,eAAe,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAE7D;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,oBAAoB,iCAAiC,EAAE,cAAc,EAAE,uCAAuC,EAAE;AAChH,yBAAyB,iCAAiC,EAAE;;AAE5D,oBAAoB,iCAAiC,EAAE,cAAc,EAAE,uCAAuC,EAAE;AAChH,yBAAyB,iCAAiC,EAAE;;AAE5D,oBAAoB,iCAAiC,EAAE,cAAc,EAAE,uCAAuC,EAAE;AAChH,yBAAyB,iCAAiC,EAAE;;AAE5D,oBAAoB,gCAAgC,GAAG,cAAc,EAAE,sCAAsC,EAAE;AAC/G,yBAAyB,gCAAgC,EAAE;;AAE3D,cAAc,gBAAgB,EAAE,eAAe,EAAE;;AAEjD,6BAA6B;AAC7B;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA,0BAA0B,mBAAmB,EAAE;;AAE/C,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA,qCAAqC,mCAAmC,EAAE,cAAc,EAAE,qCAAqC,EAAE;AACjI,yBAAyB,YAAY,EAAE,eAAe,EAAE;AACxD,wBAAwB,oCAAoC,EAAE,cAAc,EAAE,sCAAsC,EAAE;;AAEtH,iBAAiB,eAAe,EAAE,+BAA+B,EAAE;;AAEnE,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,oBAAoB;AACpB,eAAe,cAAc,EAAE;AAC/B,eAAe,cAAc,EAAE;;AAE/B,4BAA4B;AAC5B;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,mBAAmB,qCAAqC,EAAE;AAC1D,0BAA0B,+BAA+B,EAAE;;AAE3D;EACE,WAAW;EACX,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA,sBAAsB,kCAAkC,EAAE,aAAa,EAAE;;AAEzE;EACE,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,+BAA+B;EAC/B,sCAAsC;EACtC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,4BAA4B;EAC5B,gCAAgC;EAChC,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,kFAAkF;EAClF,uCAAuC;EACvC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC,+CAA+C;EAC/C,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,+CAA+C;AACjD;AACA,iCAAiC,mBAAmB,EAAE;AACtD,iBAAiB,iCAAiC,EAAE;AACpD,iBAAiB,iCAAiC,EAAE,aAAa,EAAE;AACnE,iBAAiB,gCAAgC,EAAE,YAAY,EAAE;AACjE,kBAAkB,eAAe,EAAE,cAAc,EAAE;AACnD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD;EACE,SAAO;EACP,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD,iCAAiC,mBAAmB,EAAE;AACtD,iCAAiC,2DAA2D,EAAE;AAC9F,iCAAiC,mBAAmB,EAAE;AACtD,iCAAiC,mBAAmB,EAAE,iCAAiC,EAAE;AACzF,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,gCAAgC,EAAE;AACnE,iCAAiC,cAAc,EAAE,iCAAiC,EAAE;AACpF,iCAAiC,iCAAiC,EAAE,cAAc,EAAE;AACpF,iCAAiC,gCAAgC,EAAE;AACnE,iCAAiC,cAAc,EAAE,iCAAiC,EAAE;AACpF,iCAAiC,mBAAmB,EAAE,iCAAiC,EAAE;AACzF,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,mBAAmB,EAAE,iCAAiC,EAAE,cAAc,EAAE;AACzG,iCAAiC,qBAAqB,EAAE;AACxD,iCAAiC,mBAAmB,EAAE,iCAAiC,EAAE,cAAc,EAAE;AACzG,iCAAiC,mBAAmB,EAAE,iCAAiC,EAAE,cAAc,EAAE;AACzG,iCAAiC,gBAAgB,EAAE,cAAc,EAAE;AACnE,iCAAiC,gCAAgC,EAAE,iCAAiC,EAAE;AACtG,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,iCAAiC,EAAE;AACpE,iCAAiC,gCAAgC,EAAE,kCAAkC,EAAE,cAAc,EAAE;AACvH,mCAAmC,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC5F,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,gCAAgC,EAAE,kCAAkC,EAAE;AACvG,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB;;;;;;;GAOC;AACH;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB;;uEAEqE;EACrE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,+CAA+C;EAC/C,eAAe;AACjB;AACA,6BAA6B,mBAAmB,EAAE;AAClD,mBAAmB,2BAA2B,EAAE,gBAAgB,EAAE,WAAW,EAAE,cAAc,EAAE;AAC/F,mBAAmB,4BAA4B,EAAE,YAAY,EAAE,cAAc,EAAE,sBAAsB,EAAE,eAAe,EAAE;AACxH,uBAAuB,SAAO,EAAE,WAAW,EAAE,kCAAkC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACvH,mBAAmB,YAAY,EAAE,oDAAoD,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AACvI,mBAAmB,cAAc,EAAE,gBAAgB,EAAE,WAAW,EAAE,iBAAiB,EAAE,cAAc,EAAE;;AAErG,qBAAqB;AACrB;EACE,YAAY,sBAAsB,EAAE;EACpC,eAAe,WAAW,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,YAAY,EAAE,QAAQ,EAAE,kBAAkB,EAAE,8CAA8C,EAAE;EAC/J,qBAAqB,aAAa,EAAE;EACpC,eAAe,iBAAiB,EAAE,oCAAoC,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;EACpI,sBAAsB,4BAA4B,EAAE,8BAA8B,EAAE;EACpF,YAAY,aAAa,EAAE;AAC7B","sourcesContent":["/* ══ Admin Panel ═══════════════════════════════════════════════════════════ */\n\n.adm-wrap {\n  min-height: calc(100vh - var(--topbar-h, 62px));\n  display: flex;\n  background: #050308;\n  font-family: 'Segoe UI', sans-serif;\n}\n\n/* ── Sidebar ── */\n.adm-sidebar {\n  width: 220px;\n  flex-shrink: 0;\n  background: linear-gradient(180deg, #0a0618 0%, #060312 100%);\n  border-right: 1px solid rgba(240, 192, 64, 0.14);\n  display: flex;\n  flex-direction: column;\n  padding: 24px 0 16px;\n  min-height: 100%;\n}\n\n.adm-sidebar-title {\n  font-family: 'Cinzel', Georgia, serif;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 3px;\n  color: rgba(240, 192, 64, 0.5);\n  padding: 0 20px 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  margin-bottom: 8px;\n}\n\n.adm-nav-btn {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 11px 20px;\n  background: none;\n  border: none;\n  border-left: 3px solid transparent;\n  color: rgba(210, 195, 250, 0.6);\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.15s;\n}\n\n.adm-nav-btn:hover {\n  background: rgba(255, 255, 255, 0.04);\n  color: rgba(210, 195, 250, 0.9);\n}\n\n.adm-nav-btn.active {\n  background: rgba(240, 192, 64, 0.07);\n  border-left-color: #f0c040;\n  color: #f0c040;\n}\n\n.adm-nav-icon { font-size: 15px; width: 20px; text-align: center; }\n\n.adm-badge {\n  margin-left: auto;\n  background: rgba(240, 100, 64, 0.85);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  border-radius: 10px;\n  padding: 1px 7px;\n  min-width: 18px;\n  text-align: center;\n}\n\n/* ── Main content ── */\n.adm-main {\n  flex: 1;\n  padding: 28px 32px;\n  overflow-y: auto;\n  min-width: 0;\n}\n\n.adm-section-title {\n  font-family: 'Cinzel', Georgia, serif;\n  font-size: 16px;\n  font-weight: 700;\n  color: #f0c040;\n  letter-spacing: 2px;\n  margin-bottom: 20px;\n}\n\n/* ── Stat cards ── */\n.adm-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 16px;\n  margin-bottom: 32px;\n}\n\n.adm-stat-card {\n  background: linear-gradient(135deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02));\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  padding: 18px 20px;\n  transition: border-color 0.2s;\n}\n\n.adm-stat-card:hover { border-color: rgba(240, 192, 64, 0.25); }\n\n.adm-stat-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 2px;\n  color: rgba(210, 195, 250, 0.45);\n  text-transform: uppercase;\n  margin-bottom: 6px;\n}\n\n.adm-stat-value {\n  font-size: 28px;\n  font-weight: 800;\n  color: #fff;\n  line-height: 1;\n}\n\n.adm-stat-sub {\n  font-size: 11px;\n  color: rgba(240, 100, 64, 0.85);\n  margin-top: 4px;\n}\n\n/* ── Toolbar row ── */\n.adm-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.adm-search {\n  flex: 1;\n  min-width: 180px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 7px;\n  color: #fff;\n  font-size: 13px;\n  padding: 8px 12px;\n  outline: none;\n  transition: border-color 0.15s;\n}\n\n.adm-search::placeholder { color: rgba(255, 255, 255, 0.25); }\n.adm-search:focus { border-color: rgba(240, 192, 64, 0.4); }\n\n.adm-select {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 7px;\n  color: rgba(210, 195, 250, 0.8);\n  font-size: 12px;\n  padding: 8px 10px;\n  cursor: pointer;\n  outline: none;\n}\n\n.adm-select option { background: #0a0618; color: #fff; }\n\n/* ── Table ── */\n.adm-table-wrap {\n  overflow-x: auto;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.adm-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.adm-table thead tr {\n  background: rgba(255, 255, 255, 0.04);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.adm-table th {\n  padding: 10px 14px;\n  text-align: left;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  color: rgba(210, 195, 250, 0.4);\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.adm-table td {\n  padding: 11px 14px;\n  color: rgba(255, 255, 255, 0.82);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n  vertical-align: middle;\n}\n\n.adm-table tbody tr:last-child td { border-bottom: none; }\n\n.adm-table tbody tr:hover td { background: rgba(255, 255, 255, 0.025); }\n\n.adm-id-cell { color: rgba(255, 255, 255, 0.25); font-size: 11px; }\n\n.adm-name-cell { font-weight: 600; color: #fff; }\n\n.adm-email-cell { color: rgba(210, 195, 250, 0.55); font-size: 12px; }\n\n.adm-date-cell { color: rgba(255, 255, 255, 0.3); font-size: 11px; white-space: nowrap; }\n\n/* ── Role badge ── */\n.adm-role {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  border-radius: 5px;\n  padding: 2px 8px;\n  text-transform: uppercase;\n}\n\n.adm-role-admin   { background: rgba(240,64,64,0.18);  color: #ff7070; border: 1px solid rgba(240,64,64,0.3);  }\n.adm-role-partner { background: rgba(240,192,64,0.14); color: #f0c040; border: 1px solid rgba(240,192,64,0.3); }\n.adm-role-user    { background: rgba(123,79,212,0.14); color: #b09af0; border: 1px solid rgba(123,79,212,0.25); }\n\n/* ── Status badge ── */\n.adm-status {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  border-radius: 5px;\n  padding: 2px 8px;\n}\n\n.adm-status-approved { background: rgba(64,200,100,0.15); color: #50e080; border: 1px solid rgba(64,200,100,0.3); }\n.adm-status-pending  { background: rgba(240,192,64,0.12); color: #f0c040; border: 1px solid rgba(240,192,64,0.25); }\n.adm-status-rejected { background: rgba(240,64,64,0.12);  color: #ff7070; border: 1px solid rgba(240,64,64,0.25); }\n\n/* ── Active toggle ── */\n.adm-active-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.adm-active-badge.on  { color: #50e080; }\n.adm-active-badge.off { color: rgba(255,255,255,0.25); }\n\n/* ── Action buttons ── */\n.adm-actions { display: flex; align-items: center; gap: 6px; }\n\n.adm-btn {\n  border: none;\n  border-radius: 5px;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 4px 10px;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.adm-btn-approve  { background: rgba(64,200,100,0.15); color: #50e080; border: 1px solid rgba(64,200,100,0.25); }\n.adm-btn-approve:hover { background: rgba(64,200,100,0.28); }\n\n.adm-btn-reject   { background: rgba(240,100,64,0.15); color: #ff9060; border: 1px solid rgba(240,100,64,0.25); }\n.adm-btn-reject:hover  { background: rgba(240,100,64,0.28); }\n\n.adm-btn-toggle   { background: rgba(240,192,64,0.12); color: #f0c040; border: 1px solid rgba(240,192,64,0.22); }\n.adm-btn-toggle:hover  { background: rgba(240,192,64,0.22); }\n\n.adm-btn-delete   { background: rgba(240,40,40,0.12);  color: #ff5050; border: 1px solid rgba(240,40,40,0.22); }\n.adm-btn-delete:hover  { background: rgba(240,40,40,0.25); }\n\n.adm-btn-sm { padding: 3px 8px; font-size: 10px; }\n\n/* ── Role select inline ── */\n.adm-role-select {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 5px;\n  color: rgba(210, 195, 250, 0.8);\n  font-size: 11px;\n  padding: 3px 6px;\n  cursor: pointer;\n  outline: none;\n}\n\n.adm-role-select option { background: #0a0618; }\n\n/* ── Pagination ── */\n.adm-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin-top: 20px;\n}\n\n.adm-page-btn {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  color: rgba(210, 195, 250, 0.7);\n  font-size: 12px;\n  font-weight: 600;\n  padding: 5px 12px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.adm-page-btn:hover:not(:disabled) { background: rgba(240, 192, 64, 0.1); color: #f0c040; border-color: rgba(240, 192, 64, 0.3); }\n.adm-page-btn:disabled { opacity: 0.3; cursor: default; }\n.adm-page-btn.current { background: rgba(240, 192, 64, 0.14); color: #f0c040; border-color: rgba(240, 192, 64, 0.35); }\n\n.adm-page-info { font-size: 12px; color: rgba(255, 255, 255, 0.3); }\n\n/* ── Empty ── */\n.adm-empty {\n  text-align: center;\n  padding: 48px 20px;\n  color: rgba(255, 255, 255, 0.2);\n  font-size: 14px;\n}\n\n/* ── Loading ── */\n.adm-loading {\n  text-align: center;\n  padding: 40px;\n  color: rgba(210, 195, 250, 0.4);\n  font-size: 13px;\n}\n\n/* ── Log table ── */\n.adm-log-ok  { color: #50e080; }\n.adm-log-bad { color: #ff7070; }\n\n/* ── Modal form inputs ── */\n.adm-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  color: rgba(200, 180, 255, 0.5);\n  text-transform: uppercase;\n  margin-bottom: 5px;\n}\n\n.adm-input {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: #fff;\n  font-size: 13px;\n  padding: 8px 12px;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n  font-family: inherit;\n}\n\n.adm-input:focus { border-color: rgba(240, 192, 64, 0.4); }\n.adm-input::placeholder { color: rgba(255, 255, 255, 0.2); }\n\n.adm-textarea {\n  width: 100%;\n  background: rgba(255,255,255,0.05);\n  border: 1px solid rgba(255,255,255,0.12);\n  border-radius: 6px;\n  padding: 8px 10px;\n  color: rgba(255,255,255,0.88);\n  font-size: 13px;\n  font-family: inherit;\n  resize: vertical;\n  transition: border-color 0.15s;\n  box-sizing: border-box;\n}\n.adm-textarea:focus { border-color: rgba(240,192,64,0.4); outline: none; }\n\n.adm-field-label {\n  display: block;\n  font-size: 11px;\n  color: rgba(255,255,255,0.45);\n  margin-bottom: 4px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n/* ── Export/Import toolbar group ── */\n.adm-export-group {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: rgba(255,255,255,0.03);\n  border: 1px solid rgba(255,255,255,0.07);\n  border-radius: 7px;\n  padding: 4px 8px;\n}\n\n.adm-export-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color: rgba(210,195,250,0.35);\n  text-transform: uppercase;\n  margin-right: 4px;\n  white-space: nowrap;\n}\n\n/* ── Progress bar ── */\n.adm-progress-wrap {\n  margin: 10px 0 14px;\n  padding: 12px 16px;\n  background: rgba(240,192,64,0.05);\n  border: 1px solid rgba(240,192,64,0.18);\n  border-radius: 8px;\n}\n\n.adm-progress-label {\n  font-size: 12px;\n  color: rgba(200,180,255,0.65);\n  margin-bottom: 8px;\n}\n\n.adm-progress-bar {\n  height: 5px;\n  background: rgba(255,255,255,0.06);\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.adm-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #f0c040, #ffdc70);\n  border-radius: 3px;\n  transition: width 0.3s ease;\n}\n\n/* ── Error bar ── */\n.adm-error-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  background: rgba(240,64,64,0.1);\n  border: 1px solid rgba(240,64,64,0.25);\n  border-radius: 7px;\n  color: #ff8080;\n  font-size: 12px;\n  padding: 9px 14px;\n  margin-bottom: 12px;\n}\n\n.adm-error-bar button {\n  background: none;\n  border: none;\n  color: #ff8080;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 0 4px;\n  line-height: 1;\n}\n\n/* ── Type / status inline badges ── */\n.adm-type-badge {\n  font-size: 10px;\n  color: rgba(210,195,250,0.5);\n  background: rgba(123,79,212,0.1);\n  border: 1px solid rgba(123,79,212,0.15);\n  border-radius: 4px;\n  padding: 1px 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.adm-status-dot {\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* ── Modal backdrop + box ── */\n.adm-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  background: rgba(0,0,0,0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.adm-modal-box {\n  background: #0d0a18;\n  border: 1px solid rgba(240,192,64,0.22);\n  border-radius: 16px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  padding: 28px;\n}\n\n.adm-modal-title {\n  font-family: 'Cinzel', serif;\n  font-size: 15px;\n  color: #f0c040;\n  margin-bottom: 20px;\n}\n\n/* ── External import button ── */\n.adm-btn-ext-import {\n  background: linear-gradient(135deg, rgba(100,180,255,0.12), rgba(80,150,255,0.08));\n  border: 1px solid rgba(100,180,255,0.3);\n  color: #80c8ff;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.adm-btn-ext-import:hover:not(:disabled) {\n  background: rgba(100,180,255,0.2);\n  border-color: rgba(100,180,255,0.55);\n}\n.adm-btn-ext-import:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n/* ── External import results panel ── */\n.adm-ext-results {\n  background: rgba(10,6,24,0.9);\n  border: 1px solid rgba(100,180,255,0.2);\n  border-radius: 8px;\n  margin-bottom: 16px;\n  overflow: hidden;\n}\n.adm-ext-results-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: rgba(100,180,255,0.07);\n  border-bottom: 1px solid rgba(100,180,255,0.15);\n  padding: 9px 14px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #80c8ff;\n  letter-spacing: 0.5px;\n}\n.adm-ext-results-header button {\n  background: none;\n  border: none;\n  color: rgba(200,180,255,0.5);\n  font-size: 16px;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0 4px;\n}\n.adm-ext-result-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  font-size: 12px;\n  border-bottom: 1px solid rgba(255,255,255,0.04);\n}\n.adm-ext-result-row:last-child { border-bottom: none; }\n.adm-ext-ok    { background: rgba(80,224,128,0.04); }\n.adm-ext-skip  { background: rgba(240,192,64,0.03); opacity: 0.65; }\n.adm-ext-error { background: rgba(255,80,80,0.04); opacity: 0.7; }\n.adm-ext-status { font-size: 14px; flex-shrink: 0; }\n.adm-ext-ok    .adm-ext-status { color: #50e080; }\n.adm-ext-skip  .adm-ext-status { color: #f0c040; }\n.adm-ext-error .adm-ext-status { color: #ff5050; }\n.adm-ext-title {\n  flex: 1;\n  color: rgba(220,210,255,0.85);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.adm-ext-reason {\n  font-size: 10px;\n  color: rgba(200,180,255,0.4);\n  white-space: nowrap;\n}\n\n/* ── External source badge in table ── */\n.adm-ext-badge {\n  display: inline-block;\n  font-size: 11px;\n  margin-right: 5px;\n  vertical-align: middle;\n  opacity: 0.7;\n}\n\n/* ── Heatmap tab ── */\n.adm-hm-stats {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n.adm-hm-stat {\n  flex: 1;\n  min-width: 100px;\n  background: rgba(255,255,255,0.03);\n  border: 1px solid rgba(255,255,255,0.07);\n  border-radius: 8px;\n  padding: 12px 16px;\n}\n.adm-hm-stat-val {\n  font-family: 'Cinzel', serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: #f0c040;\n  line-height: 1.1;\n  margin-bottom: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.adm-hm-stat-lbl {\n  font-size: 10px;\n  color: rgba(200,180,255,0.4);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n/* ── Light theme overrides for admin panel ── */\nbody.light .adm-wrap           { background: #eef3fb; }\nbody.light .adm-sidebar        { background: linear-gradient(180deg,#1a1050 0%,#231466 100%); }\nbody.light .adm-content        { background: #f4f8ff; }\nbody.light .adm-card           { background: #ffffff; border-color: rgba(15,32,63,0.12); }\nbody.light .adm-table          { color: #101a34; }\nbody.light .adm-table thead tr { background: rgba(91,88,214,0.08); }\nbody.light .adm-table th       { color: #5b58d6; border-color: rgba(15,32,63,0.10); }\nbody.light .adm-table td       { border-color: rgba(15,32,63,0.07); color: #354161; }\nbody.light .adm-table tr:hover { background: rgba(91,88,214,0.05); }\nbody.light .adm-section-title  { color: #101a34; border-color: rgba(91,88,214,0.2); }\nbody.light .adm-modal-box      { background: #ffffff; border-color: rgba(91,88,214,0.2); }\nbody.light .adm-modal-title    { color: #4e46b4; }\nbody.light .adm-input          { background: #f4f8ff; border-color: rgba(15,32,63,0.18); color: #101a34; }\nbody.light .adm-input:focus    { border-color: #5b58d6; }\nbody.light .adm-textarea       { background: #f4f8ff; border-color: rgba(15,32,63,0.18); color: #101a34; }\nbody.light .adm-select         { background: #f4f8ff; border-color: rgba(15,32,63,0.18); color: #354161; }\nbody.light .adm-select option  { background: #fff; color: #101a34; }\nbody.light .adm-toolbar        { background: rgba(91,88,214,0.05); border-color: rgba(15,32,63,0.10); }\nbody.light .adm-loading        { color: #5d6a88; }\nbody.light .adm-empty          { color: #5d6a88; }\nbody.light .adm-id-cell        { color: #5b58d6; }\nbody.light .adm-name-cell      { color: #101a34; }\nbody.light .adm-email-cell     { color: #354161; }\nbody.light .adm-date-cell      { color: #5d6a88; }\nbody.light .adm-pagination     { border-color: rgba(15,32,63,0.10); }\nbody.light .adm-page-btn       { background: rgba(91,88,214,0.06); border-color: rgba(91,88,214,0.18); color: #354161; }\nbody.light .adm-page-btn.current { background: #5b58d6; color: #fff; border-color: #5b58d6; }\nbody.light .adm-page-info      { color: #5d6a88; }\nbody.light .adm-hm-stat        { background: rgba(91,88,214,0.06); border-color: rgba(91,88,214,0.12); }\nbody.light .adm-hm-stat-val    { color: #4e46b4; }\nbody.light .adm-hm-stat-lbl    { color: #5d6a88; }\nbody.light .adm-field-label    { color: #5d6a88; }\n\n.adm-hm-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.adm-hm-legend {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 11px;\n  color: rgba(200,180,255,0.45);\n}\n.adm-hm-gradient {\n  flex: 1;\n  max-width: 220px;\n  height: 10px;\n  border-radius: 5px;\n  background: linear-gradient(90deg,\n    rgba(0,0,255,0.6),\n    rgba(0,200,255,0.7),\n    rgba(0,255,100,0.8),\n    rgba(255,255,0,0.9),\n    rgba(255,130,0,1),\n    rgba(255,0,0,1)\n  );\n}\n\n.adm-hm-canvas-wrap {\n  position: relative;\n  width: 100%;\n  background: #080510;\n  border: 1px solid rgba(240,192,64,0.1);\n  border-radius: 8px;\n  overflow: hidden;\n  aspect-ratio: 16/9;\n}\n.adm-hm-canvas {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n.adm-hm-grid {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background-image:\n    linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px);\n  background-size: 10% 10%;\n}\n.adm-hm-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Cinzel', serif;\n  font-size: 13px;\n  letter-spacing: 2px;\n  color: rgba(200,180,255,0.35);\n  text-transform: uppercase;\n  background: rgba(5,3,8,0.7);\n  z-index: 2;\n}\n\n.adm-hm-top {\n  background: rgba(255,255,255,0.02);\n  border: 1px solid rgba(255,255,255,0.07);\n  border-radius: 8px;\n  padding: 14px 16px;\n}\n.adm-hm-top-title {\n  font-family: 'Cinzel', serif;\n  font-size: 10px;\n  color: rgba(240,192,64,0.6);\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n}\n.adm-hm-top-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 5px 0;\n  border-bottom: 1px solid rgba(255,255,255,0.04);\n  font-size: 11px;\n}\n.adm-hm-top-row:last-child { border-bottom: none; }\n.adm-hm-top-rank { color: rgba(240,192,64,0.5); font-weight: 700; width: 24px; flex-shrink: 0; }\n.adm-hm-top-pos  { color: rgba(200,180,255,0.6); width: 120px; flex-shrink: 0; font-family: monospace; font-size: 10px; }\n.adm-hm-top-bar-wrap { flex: 1; height: 6px; background: rgba(255,255,255,0.06); border-radius: 3px; overflow: hidden; }\n.adm-hm-top-bar  { height: 100%; background: linear-gradient(90deg, #4040ff, #ff2020); border-radius: 3px; transition: width .4s ease; }\n.adm-hm-top-cnt  { color: #f0c040; font-weight: 700; width: 36px; text-align: right; flex-shrink: 0; }\n\n/* ── Responsive ── */\n@media (max-width: 768px) {\n  .adm-wrap { flex-direction: column; }\n  .adm-sidebar { width: 100%; flex-direction: row; overflow-x: auto; padding: 8px; gap: 4px; border-right: none; border-bottom: 1px solid rgba(240,192,64,0.14); }\n  .adm-sidebar-title { display: none; }\n  .adm-nav-btn { border-left: none; border-bottom: 2px solid transparent; padding: 8px 14px; white-space: nowrap; border-radius: 6px; }\n  .adm-nav-btn.active { border-bottom-color: #f0c040; border-left-color: transparent; }\n  .adm-main { padding: 16px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
